import { render } from "./ResumoModulos.vue?vue&type=template&id=3e4c99d9"
import script from "./ResumoModulos.vue?vue&type=script&lang=js"
export * from "./ResumoModulos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__